export default __webpack_public_path__ + "static/media/giftbox-tick.8f9dabb3.svg";